import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function About() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-5 md:px-8 py-14 md:py-20">
        <p className="text-sm font-bold uppercase tracking-widest text-[#64748B] mb-3">
          About
        </p>
        <h1
          data-testid="about-title"
          className="font-display font-black text-4xl md:text-5xl tracking-tight mb-6"
        >
          Tools that give teachers time back.
        </h1>
        <div className="prose prose-lg max-w-none text-[#1F2937]">
          <p className="text-lg leading-relaxed">
            TeacherToolsLab is a small project built to help K-12 teachers,
            homeschool parents, and tutors create classroom-ready resources without
            the headache of fancy software or expensive subscriptions.
          </p>
          <p className="text-lg leading-relaxed">
            Our first tool — the <strong>Free Rubric Generator</strong> — turns a
            quick set of choices (state, subject, grade, assignment topic) into a
            clean, printable rubric you can use the same day. No accounts. No
            paywalls. No clutter.
          </p>
          <h2 className="font-display font-black text-2xl md:text-3xl mt-10 mb-3">
            Why we built it
          </h2>
          <p className="text-lg leading-relaxed">
            Teachers shouldn't have to spend their evenings hand-formatting a rubric
            for every assignment. The tools here are designed to do the boring
            structural work so educators can spend their energy on the parts that
            matter — teaching, feedback, and the kids in front of them.
          </p>
          <h2 className="font-display font-black text-2xl md:text-3xl mt-10 mb-3">
            What's coming next
          </h2>
          <ul className="text-lg leading-relaxed">
            <li>Quiz generator</li>
            <li>Lesson plan generator</li>
            <li>Writing prompt generator</li>
            <li>Exit ticket generator</li>
            <li>Classroom activity generator</li>
          </ul>
          <p className="text-lg leading-relaxed mt-6">
            Got an idea or feedback?{" "}
            <a href="/contact" className="underline font-semibold">
              Reach out — we read every message.
            </a>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
